import React, { useEffect } from "react";
import Header from "./Header";
import { useNavigate } from "react-router-dom";

import { apiURL } from "../../api";

function Users(props) {
  const Navigate = useNavigate();
  const adminDetails = JSON.parse(localStorage.getItem("adminDetails"));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    const UsersPageLoaded = async () => {
      try {
        if (adminDetails.email === "" || adminDetails.password === "") {
          Navigate("/admin");
        } else {
          const res = await fetch(
            `${apiURL}/adminusers/${adminDetails.email}/${adminDetails.password}`,
            {
              method: "GET",
              headers: {
                "Content-Type": "application/json",
              },
            }
          );

          await res.json();
        }
      } catch (error) {
        Navigate("/admin");
      }
    };
    UsersPageLoaded();
  }, [Navigate, adminDetails.email, adminDetails.password]);

  return (
    <div className="dark:bg-dark" style={{ minHeight: "100vh" }}>
      <Header enableDarkMode={props.enableDarkMode} />
      <div className="flex justify-between items-center text-gray-600">
        <div className="w-[88%] mx-auto">
          <table className="w-full">
            <thead>
              <tr className="dark:bg-slate-800 dark:text-white bg-background text-gray-800">
                <th className="py-2 px-4 font-semibold">Name</th>
                <th className="py-2 px-4 font-semibold">Email</th>
                <th className="py-2 px-4 font-semibold">City</th>
                <th className="py-2 px-4 font-semibold">Address</th>
              </tr>
            </thead>
            <tbody className="dark:bg-slate-500 dark:text-white">
              {props.users.map((user) => {
                return (
                  <tr className="text-center" key={user._id}>
                    <td className="py-2 px-4">{user.name}</td>
                    <td className="py-2 px-4">{user.email}</td>
                    <td className="py-2 px-4">{user.city}</td>
                    <td className="py-2 px-4">{user.address}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default Users;
